import React, { useState, useEffect, useContext } from "react";
import { QRCodeCanvas } from "qrcode.react";

import Swal from "sweetalert2";

import api, { AuthContext, showAlert } from "../../util/api";

import { useParams, Link, useNavigate } from "react-router-dom";
import { useRef } from "react";
import Footer from "../../footer";
import Navbar from "../../header";

export default function BitcoinDepositPage() {
    const { token, User } = useContext(AuthContext);

    const [address, setAddress] = useState("");
    const [status, setStatus] = useState("");
    const [copied, setCopied] = useState(false);
    const [hideinput, setHide] = useState(false);
    const [paymentId, setPaymentId] = useState();
    const [deposit, setDeposit] = useState();
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(false);
    const router = useNavigate();
    const { currency, appointment_id } = useParams();
    let  Currency_Type  = "";

  if (currency === 'usdttrc20') {
    Currency_Type = "USDT(TRC20)";
  }

  if (currency === 'usdterc20') {
    Currency_Type = "USDT(ERC20)";

  }

  if (currency === 'btc') {
     Currency_Type = "BTC";
  }


    const generateAddress = async () => {

       

        setLoading(true);
        const response = await api.get(
            `/generate_btc_address?currency=${currency}&appointment_id=${appointment_id}`
        );
        const outcome = response.data;
        if (outcome.status == "successful") {
            setLoading(false);
            const Address = outcome.address;
            setHide(true);
            setAddress(Address);
            setPaymentId(outcome.payment_id);
            setDeposit(outcome.deposit);
            setTotal(outcome.total);
            setStatus("Waiting");
            setCopied(false);
        } else {
            setLoading(false);
            showAlert('error', 'error', outcome.message);
        }
    };







    const checkStatus = async () => {

        setLoading(true);
        const response = await api.get(
            `/crypto/payments/check?payment_id=${paymentId}&user_id=${User.id}`
        );
        const outcome = response.data;
        //if(outcome.status  != "failed"){ 
        setStatus(outcome.status);
        //}
        setLoading(false);


    };

    const copyAddress = () => {
        navigator.clipboard.writeText(address);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    useEffect(() => {
        if (User == null) {
            router("/login");
        } else {

            generateAddress();
        }
    }, []);

    const restart = () => {
        Swal.fire({
            title: "Are you sure?",
            text: "This will cancel the current deposit process.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, cancel it!",
        }).then(async (result) => {
            if (result.isConfirmed) {

                setAddress("");
                setStatus("");

                setHide(false);
                Swal.fire(
                    "Cancelled!",
                    "The deposit process has been cancelled.",
                    "success"
                );
                await api.get(
                    `/delete-usdt-address?user_id=${User["id"]}&payment_id=${paymentId}`
                );


            }
        });
    };

    const pageStyle = {
        fontFamily: "Segoe UI, sans-serif",
        background: "linear-gradient(to right, #232526, #414345)",
        minHeight: "100vh",
        padding: "30px",
        color: "#fff",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    };

    const cardStyle = {
        backgroundColor: "#2c2f33",
        borderRadius: "15px",
        padding: "30px",
        maxWidth: "400px",
        width: "100%",
        boxShadow: "0 8px 20px rgba(0, 0, 0, 0.3)",
        marginBottom: "30px",
    };



    const buttonStyle = {
        width: "100%",
        padding: "15px",
        backgroundColor: "#00c9a7",
        color: "#fff",
        border: "none",
        borderRadius: "10px",
        fontSize: "16px",
        cursor: "pointer",
        marginBottom: "15px",
        transition: "background-color 0.3s ease",
    };

    const copyButtonStyle = {
        backgroundColor: "#4caf50",
        marginTop: "10px",
    };

    const qrStyle = {
        textAlign: "center",
        marginTop: "20px",
    };

    const statusStyle = {
        backgroundColor: "#1e2124",
        padding: "12px",
        borderRadius: "8px",
        marginTop: "20px",
        textAlign: "center",
        fontWeight: "bold",
        color: "#00e6a1",
    };

    const copiedStyle = {
        color: "#00ffcc",
        fontSize: "14px",
        marginTop: "5px",
        textAlign: "center",
    };




    // Debounce hooks for BTC and USD input





    return (
        <>
            <Navbar menuColor="red" />


            <div style={{ ...pageStyle }}>


                <div style={{ marginTop: "200px" }}></div>
                <h2 style={{ fontSize: "28px", marginBottom: "20px", color: "#00e6a1" }}>

                    <Link to={`/payment_options/${appointment_id}`}><span>&#x2B05;</span> </Link> PAY WITH   {Currency_Type}                    </h2>

                <div style={cardStyle}>


                    {hideinput === false && (
                        <>

                               <h3  style={{textAlign:"center" , color:"white"}}> Loading.... </h3> 

                        </>
                    )}

                    {hideinput === true && (
                        <>
                            <div style={{ wordBreak: "break-all", fontSize: "14px" }}>
                                <strong>Deposit Address:</strong>
                                <div
                                    style={{
                                        margin: "10px 0",
                                        background: "#1e2124",
                                        padding: "10px",
                                        borderRadius: "6px",
                                    }}
                                >
                                    {address}
                                </div>

                                <button
                                    style={{ ...buttonStyle, ...copyButtonStyle }}
                                    onClick={copyAddress}
                                >
                                    Copy Address
                                </button>
                                {copied && <div style={copiedStyle}>Copied!</div>}

                                <div style={qrStyle}>
                                    <QRCodeCanvas
                                        value={address}
                                        size={150}
                                        level="H"
                                        bgColor="#fff"
                                        fgColor="#000"
                                    />
                                </div>

                                <p
                                    style={{
                                        marginTop: "20px",
                                        color: "#ffcc00",
                                        fontWeight: "bold",
                                        textAlign: "left",
                                    }}
                                >
                                    ⚠️ Please deposit exactly {" "}
                                    <span style={{ color: "#00e6a1" }}>{Number(total)} {Currency_Type}</span>{" "}
                                    to the above address. Sending a different amount may result in
                                    loss of funds  .

                                    <br /> <br />
                                    Amount :   <span style={{ color: "#00e6a1" }}>{deposit.crypto_amount} {Currency_Type}</span>
                                    <br />
                                    Processing  Fee  :   <span style={{ color: "#00e6a1" }}>{deposit.fee} {Currency_Type}</span>
                                    <br />
                                    Total Amount :   <span style={{ color: "#00e6a1" }}>{total} {Currency_Type}</span>
                                    <br /><br />

                                    Please ensure you send exactly this amount <span style={{ color: "#00e6a1" }}>{total} {Currency_Type}</span>   to avoid any issues.
                                </p>
                            </div>

                            <button style={buttonStyle} onClick={checkStatus}>
                                Check Deposit Status
                            </button>

                            <button
                                style={{ ...buttonStyle, backgroundColor: "red" }}
                                onClick={restart}
                            >
                                Cancel
                            </button>

                            {status && <div style={statusStyle}>{status}</div>}
                        </>
                    )}
                </div>

                {/*  {depositHistory.length > 0 && (
            <div style={historyCardStyle}>
                <h3 style={{ marginBottom: "15px", color: "#fff" }}>Deposit History</h3>
                {depositHistory.map((entry) => (
                    <div key={entry.id} style={historyItemStyle}>
                        <div><strong>Amount:</strong> {entry.amount} USDT</div>
                        <div><strong>Address:</strong> {entry.address}</div>
                        <div><strong>Date:</strong> {entry.time}</div>
                        <div><strong>Status:</strong> {entry.status}</div>
                    </div>
                ))}
            </div>
        )} */}
            </div>


            <Footer />
        </>
    );
}
